module.exports = __webpack_public_path__ + "static/img/hair_10.ddf800b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_10.png
// module id = jYmp
// module chunks = 0